const extensionFromUrl = (url) => {
  try {
    const path = new URL(url, window.location.origin).pathname;
    const match = path.match(/\.([a-zA-Z0-9]{2,5})$/);
    return match ? match[1].toLowerCase() : 'jpg';
  } catch {
    return 'jpg';
  }
};

const slugify = (value) => String(value || 'property')
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '')
  .slice(0, 60) || 'property';

export const buildPropertyPhotoFilename = (title, index, url) => {
  const ext = extensionFromUrl(url);
  return `${slugify(title)}-photo-${index + 1}.${ext}`;
};

export const buildPropertyVideoFilename = (title, url, fallbackName = '') => {
  const fromUrl = extensionFromUrl(url);
  const fromName = String(fallbackName || '').split('.').pop()?.toLowerCase();
  const ext = ['mp4', 'mov', 'avi', 'mkv', 'mpg', 'mpeg'].includes(fromUrl)
    ? fromUrl
    : (['mp4', 'mov', 'avi', 'mkv', 'mpg', 'mpeg'].includes(fromName) ? fromName : 'mp4');
  return `${slugify(title)}-video.${ext}`;
};

export const downloadImageUrl = async (url, filename) => {
  if (!url) return false;
  const safeName = filename || `photo.${extensionFromUrl(url)}`;

  try {
    const response = await fetch(url, { mode: 'cors' });
    if (!response.ok) throw new Error('fetch failed');
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = safeName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(blobUrl);
    return true;
  } catch {
    const link = document.createElement('a');
    link.href = url;
    link.download = safeName;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    link.remove();
    return true;
  }
};
